// extracted by mini-css-extract-plugin
export default {"menu":"d1a2afc0a135f3d958ae787c13b3e791"};